class LanguageContainer {
    constructor() {

    }

    set(language) {
        this.currentLanguage = language;
    }

    get() {
        return this.currentLanguage;
    }
}

module.exports = new LanguageContainer();


// WEBPACK FOOTER //
// ./app/helpers/language-container.js